import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-view_product_content-view';
/**
 * Send FB pixel event when product is viewed
 */
export function trackRetailersViewProductContentView(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'ViewContent',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
